const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT} from "../../constants";
import {buildExport,prepareDataToSendController,isEdit,doAjax,pushFilterSessionCacheState,isNew,isDeleteView,isOnlyLookupDataUpdate,retriveCriteriaObjectByOperation} from "../../utilities/filtersutil";
import {actionOptions} from "./filter/actionOptions.js";
import {searchDropdown} from "./filter/searchDropdown.js";
import render from "./../../utilities/render";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";
const _ = require("underscore");

let actionCellDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html");
let actionCellDropdownItemTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html");
let actionHeaderDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html");
let actionList = actionOptions;

const targetSelector = "#CustomShippings-lookup";
run(targetSelector, ()=>{
 
  let submitModalFlow = new SubmitModalFlow();
  const lookupTable = $(targetSelector).find("#stringMapping-lookup-wrapper");
  const dataTableComponentData = $(targetSelector).data("lookup-data");
  const savedViews = $(targetSelector).data("saved-view");
  const filterSearchUrl =  $(targetSelector).data("filter-search-url");
  const portletNamespace = $(targetSelector).data("portlet-namespace")
  const shipmentMethodList = $(targetSelector).data("shipment-method-list");
  const deleteShipmentMethodUrl = $(targetSelector).data("delete-shipment-method-url");
  const editShipmentMethodUrl = $(targetSelector).data("new-shipment-method-url");
  //submitModalFlow.init(); 
  let exportModal = new buildExport();
  const generateExportUrl = $(targetSelector).data("export-url");
  let targetObject = "";

  let CustomShippingsLookup = new LookupTable({ 

    target: lookupTable, 
    minWidthClass: "q-min-width-sm-til-md",
    mobileColumns: [
      {
        render: renderActionWrap,
        orderable: false,
        class: 'dtc-action-column',
        title: "Actions"
      },
			{
        data: "shmShipmentMethod",
        title: "Custom Shipping String Name",
      },
      {

        data: "shmShipmentMethodCode",
        render: formatCodeToName,
        title: "Shipping Method/Service Level"
      },
      {
        data: "shmAddressType",
        title: "Address Type",
      },
      {
        render: formateDate,
        data: "shmCreatedDate",
        title: "Created Date"
      }
      
    ],

		tableSearch: true,
    // REQUIRED: search input info
		tableSearchInput: {
      // Not required
      // placeholder: 'Custom Search Text'
      value: targetObject != "" ? targetObject.value[0] : ""
    },
		// REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: targetObject == "" ? "" : targetObject.key,
      columns: searchDropdown
    },
    // OPTIONAL: Set Saved View Array
    savedViews: savedViews,
    bulkSelect: false,
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      // Not required, just to show you can
      columnDefs: [{}],
      // Not required, just to show you can
      order: [[4, 'desc']],
      columns: [
        {
          render: renderActionWrap,
          orderable: false,
          class: 'dtc-action-column',
          title: "Actions",
          data: "shmId"
        },
        {
          data: "shmShipmentMethod",
          title: "Custom Shipping String Name",
          class: "dtc-min-width-sm"
        },
        {
          render: formatCodeToName,
          data: "shmShipmentMethodCode",
          title: "Shipping Method/Service Level",
          class: "dtc-min-width-sm"
        },
        {
          data: "shmAddressType",
          title: "Address Type",
          class: "dtc-min-width-sm"
        },
        {
          render: formateDate,
          data: "shmCreatedDate",
          title: "Created Date",
          class: 'dtc-min-width-sm'
        }
      ],
		},
    paginationData:dataTableComponentData.page,

		filterModal: {
      // REQUIRED: Sets title of modal
      title: "Custom Shipping String Mapping",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "shippingString"
    },

	/*	onBulkSelectChange: function() {
      const selectedRows = releaseOrderLookup.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');
      }
    },*/

		onFetch:function() {
			let currentData = CustomShippingsLookup.generateData();
			CustomShippingsLookup.showLoadingOverlay();
			//Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
			if(isOnlyLookupDataUpdate(currentData)){
				setTimeout(() => {
					doAjax({url: filterSearchUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
				},SUCCESS_MODAL_TIMEOUT);
			}
		}
  });

  CustomShippingsLookup.init();

  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    newRender = render(
      actionCellDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row),
      index: meta.row
    });
    return newRender;
  }


  function renderActionHeaderWrap() {
    let statusTarget = actionList["all"];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(actionHeaderDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row)
    });
    return newRender;
  }
 
  function renderActionCellList(list, data, row) {
    let renderedList = _(list).map(item => {
      return render(
        actionCellDropdownItemTemplate,
        neededActions(data, row, item)
      );
    });
    return renderedList.join("");
  }


  function neededActions(data, row, item) {
    console.log(item);
    var action = {};
      if (item.title === 'Delete') {
        action = {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: item.disabled
        };      
      }else if (item.title === 'Edit') {
        action = {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: item.disabled
        };      
      }
    return action;
  }

  $('body').on( 'click', '.delete-location', function (e) {
    e.preventDefault();
    if(shallAllowClick(this)){
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    let rowEdit = $(".data-table-component").dataTable().api().row(parent);
    let submitDeleteModalFlow = new SubmitModalFlow({
      confirmModalTitle: 'Delete Shipping String Mapping',
      confirmModalBody: `
      <div class="q-pad-all-xl">
        You have selected to delete this record from your list of active Shipping String Mappings.<br><br>
        Please select 'Submit' if you wish to proceed with deleting this record.<br><br>
        If you wish to keep this record, please select 'Cancel'.
      </div>
      `,
      confirmModalBtnText: 'Submit',
      onConfirmClick: function () {
         submitDeleteModalFlow.showLoadingModal();
          deleteShippingString(rowEdit);
          function deleteShippingString(rowEdit) {
            let shipmentString = rowEdit.data();
            location.href = `${deleteShipmentMethodUrl}&${portletNamespace}shmShipmentMethod=${shipmentString.shmShipmentMethod}`;
          };
        }
      });
      submitDeleteModalFlow.init();
      submitDeleteModalFlow.showConfirmModal();
    }
  });


    $('body').on('click', '.edit-shipment-method', function(e){
      e.preventDefault(); 
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let rowEdit = $(".data-table-component").dataTable().api().row(parent);
      let shmShipmentMethod = rowEdit.data().shmShipmentMethod;
      location.href = `${editShipmentMethodUrl}&${portletNamespace}shmShipmentMethod=${shmShipmentMethod}`;
  });
 
    function shallAllowClick(currentObj) {
      return !($(currentObj).hasClass("disabled"));
  }
 
  function initExport() {
    let exportObj  =  {
      title : $(targetSelector).data("export-popup-title"),
      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
    };
    exportModal.init(exportObj);
    exportModal.bindExportEvent(portletNamespace);
  }
  CustomShippingsLookup.init();
  handleCustomDropdownEvents();
  
  function filterSuccessFun(data) {
    let shipmentMethod = data.content;
    let page = data.page;
    CustomShippingsLookup.setNewData(shipmentMethod);
    CustomShippingsLookup.setPaginationData(page);
    pushFilterSessionCacheState();
    CustomShippingsLookup.hideLoadingOverlay();
    setExportData(CustomShippingsLookup.generateData());
  }

function setExportData(currentData) {
  exportModal.buildExportBasicURL(generateExportUrl, currentData);
  exportModal.setExportCount(currentData.totalElements);
}
 
  initExport();
  setExportData(CustomShippingsLookup.generateData());
  
  function errorFun(data) {
    CustomShippingsLookup.hideLoadingOverlay();
  }

  function formatCodeToName(data, type, row){
    let shipmentMethodName;
    if(isPresent(data)){
      shipmentMethodList.forEach(function (shipmentMethod) {
        if(data == shipmentMethod.cdmValue)
        shipmentMethodName =  shipmentMethod.cdmMeaning;
      });
   }
   else{
    shipmentMethodName = '-';
   }
      return shipmentMethodName;
  }

  function formateDate(createdDate, type, data){
		if(createdDate != null && createdDate != ""){
		  var date = new Date(createdDate); //createdDate is long time format
		  var month = date.getMonth() + 1;
		  var today = new Date();
		  var oneDay = 24*60*60*1000;
		  today.setHours(0,0,0,0);
		  date.setHours(0,0,0,0);
		  var diffDays = Math.floor(Math.abs((today.getTime() - date.getTime())/(oneDay)));
		  var friendlyText = "";
		  var datePillHTML  = ""
		  if(diffDays < 100){
		  	friendlyText = diffDays.toString() + ' Days Ago';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  if(diffDays == 0){
		    friendlyText = 'Today';
		  }else if(diffDays== 1){
		    friendlyText ='Yesterday'
		  }
		  return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
		}else{
		  return "";
		}
	}
 
  
 
  //handleCustomDropdownEvents();
 
  $("th.dtc-action-column").html(renderActionHeaderWrap());
});



// WEBPACK FOOTER //
// ./src/pages/shipmentStringMapping/lookup.js